import React from "react";
import { Button } from "../Button/Button";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from "../../config/axios-instance";
interface Props {
  setStep: (x: number) => void;
  setSuccess: (val: boolean) => void;
  handleChange: (e: any) => void;
  data: any;
  setErrors: (x: any) => void;
  errors: any;
  setForgot: (x: string) => void;
}

export const JoinFormCompany = ({
  setStep,
  setSuccess,
  handleChange,
  data,
  setErrors,
  errors,
  setForgot,
}: Props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [requestError, setRequestError] = React.useState("");

  const sendRequestDemco = async (e: any) => {
    e.preventDefault();
    await setIsLoading(true);
    if (data.company && data.job_title && data.country) {
      await axiosInstance({
        method: "post",
        url: "/join",
        data,
      })
        .then((res) => {
          if (res && res.data) {
            setSuccess(true);
            setIsLoading(false);
            setTimeout(() => {
              setSuccess(false);
            }, 2000);
            setForgot("center");
            setErrors([]);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          // setRequestError(err);
        });
    } else {
      let keys = ["company", "job_title", "country"];
      setIsLoading(false);
      await setErrors(keys.filter((el: string) => !data[el]));
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="mt-2"
    >
      <div className="field">
        <input
          type="text"
          name="company"
          id="company"
          onChange={(e: any) => handleChange(e)}
          placeholder=" "
          value={data.company}
          style={{
            borderColor: errors.includes("company") ? "red" : "#ccc",
          }}
        />
        <label htmlFor="company" className="login_password_label">
          Company Name
        </label>
      </div>
      <div className="field">
        <input
          type="text"
          name="job_title"
          id="job_title"
          onChange={(e: any) => handleChange(e)}
          placeholder=" "
          value={data.job_title}
          style={{ borderColor: errors.includes("job_title") ? "red" : "#ccc" }}
        />
        <label htmlFor="job_title" className="login_email_label">
          Job Title
        </label>
      </div>
      <div className="field">
        <input
          type="text"
          name="country"
          id="country"
          onChange={(e: any) => handleChange(e)}
          placeholder=" "
          value={data.country}
          style={{ borderColor: errors.includes("country") ? "red" : "#ccc" }}
        />
        <label htmlFor="country" className="login_password_label">
          Country
        </label>
      </div>
      <p>{requestError && requestError}</p>
      <div className="d-flex justify-content-between join_demco_btns">
        <Button
          buttonClass="submit_button_white_full_width submit_button_white_full_width_login company_join_btn"
          innerButton="Back"
          onClick={() => setStep(0)}
          icon={<FontAwesomeIcon icon={faArrowLeft} />}
        />
        <Button
          buttonClass="submit_button_white_full_width submit_button_white_full_width_login company_join_btn"
          innerButton={isLoading ? "Sending..." : "Send"}
          onClick={sendRequestDemco}
          icon={<FontAwesomeIcon icon={faCheck} />}
        />
      </div>
    </motion.div>
  );
};
